import React, { useState, useEffect } from "react";
import config from "../../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment, { months } from "moment";
import PrintHeader from "../../General/PrintHeader";
import Page from "../../General/Page";
import { calculateColumnTotal, getMonthName } from "../../General/Utility";

const PrintManageLeaves = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [selectedYear, setselectedYear] = useState("");
  const [selectedMonth, setselectedMonth] = useState("");
  const [selectedSelaryType, setselectedSelaryType] = useState("");
  const [selaryTypeName,setSelaryTypeName] = useState()


   

  useEffect(() => {
    document.title = "DPS School Management System";

    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    const year = urlParams.get("year");
    const Month = urlParams.get("month");
    const selary = urlParams.get("selarytype");
    // const selaryName = urlParams.get("selarytype")

    setselectedYear(year);
    setselectedMonth(Month);
    setselectedSelaryType(selary);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      FYear: year,
      SelectedMonth: Month,
      SalaryTypeId: selary,
    };

    //console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetArrearLeaves",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
        setSelaryTypeName(response.data.SalaryTypeName)
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, []);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      let countbreak = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++}</td>
            {/* <td>{item.ID}</td> */}
            <td>{item.Code}</td>
            <td>{item.Staff_Name}</td>
            {/* <td>{item.Father_Name}</td> */}
            <td>{item.Description}</td>
            <td>{item.Salary_Value}</td>
           

          </tr>
          
        );
      });
    } else {
      return (
        <tr>
          <td colspan="20">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <Page orientation="potrait" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <td colspan="8">
                <PrintHeader
                  title={`${selaryTypeName} Report For The Month Of ${getMonthName(
                    selectedMonth
                  )} ${selectedYear} `}
                />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Sr.</th>
              <th>Code</th>
              <th>Staff Name</th>
              {/* <th>Father Name</th> */}
              <th>Desicription</th>
              <th>Amount</th>
            </tr>
            {loading ? (
              <tr>
                <td className="text-center" colspan="5">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>{renderLedger()}

{
                                        <tr>
                                            <th className="text-end" colSpan={4}>Total Amount:</th>
                                            <th className="" colSpan={1}>{calculateColumnTotal(listOfLedger, 'Salary_Value')}</th>
                                        </tr>
                                    }


              
              </>
            )}
          </tbody>
        </table>

        <div style={{ marginTop: "30px", width: "100%" }}>
                    <table className="table table-sm table-bordered table-print" style={{ borderCollapse: "collapse", border: "transparent" }}>
                        <tbody>
                            <tr className="my-5">
                                <th style={{ width: "33.33%", textAlign: "left", textDecoration: "underline" }}>
                                    Prepared By
                                </th>
                                <th style={{ width: "33.33%", textAlign: "center", textDecoration: "underline" }}>
                                    Burser
                                </th>
                                <th style={{ width: "33.33%", textAlign: "right", textDecoration: "underline" }}>
                                    Head of Wing / Deptt
                                </th>
                            </tr>
                            <tr className="my-5">
                                <br /><br />
                            </tr>
                            <tr className="my-5">
                                <th style={{ width: "33.33%", textAlign: "left", textDecoration: "underline" }}>
                                    Admin Officer
                                </th>
                                <th style={{ width: "33.33%", textAlign: "center", textDecoration: "underline" }}>

                                </th>
                                <th style={{ width: "33.33%", textAlign: "right", textDecoration: "underline" }}>
                                    Principal
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>





















      </Page>
    </>
  );
};

export default PrintManageLeaves;
